<template>
  <div>
    <div class="back-bar" @click="$router.go(-1)">
      <i class="el-icon-arrow-left" style="color:#000000"></i>
      {{addressForm.id?'Edit':'Add'}} A New Address
    </div>
    <el-form :model="addressForm" :rules="rules" style="margin-top:0.9rem" ref="addressForm">
      <el-form-item prop="fullName">
        <el-input v-model="addressForm.fullName" :placeholder="$t('address.fullName')" clearable>
          <template slot="prepend">
            <i class="required-mark">*</i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="phoneNumber" style="margin-bottom:0.1rem;border:none">
        <m-picker v-model="addressForm.areaCode" :visible.sync="visible" title="select" show-toolbar :columns="areanolist" :custom-field="{value: 'code', label: 'code'}" @confirm="confirm" />
        <el-input v-model="addressForm.phoneNumber" :placeholder="$t('address.phoneNumber')" clearable>
          <template slot="prepend">
            <span class="f--c" @click="visible = true" style="font-size:0.32rem;color:#7B7B7B">{{addressForm.areaCode}}
              <i class="el-icon-arrow-down el-icon--right"></i>
              <i class="required-mark" style="margin-left:0.1rem">*</i>
            </span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="streetAddressLine1">
        <el-input v-model="addressForm.streetAddressLine1" :placeholder="$t('address.streetAddressLine1')" clearable>
          <template slot="prepend">
            <i class="required-mark">*</i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="streetAddressLine2">
        <el-input v-model="addressForm.streetAddressLine2" :placeholder="$t('address.streetAddressLine2')" clearable>
          <template slot="prepend">
            <i class="required-mark"> </i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="countryCode">
        <m-picker v-model="addressForm.countryCode" :visible.sync="countryvisible" title="select" show-toolbar :columns="addressData" :custom-field="{value: 'code', label: 'name_en'}" @confirm="confirm" />
        <div @click="countryvisible = true">
          <el-input v-model="name_en" :readonly="true" :placeholder="$t('address.country')">
            <template slot="prepend">
              <i class="required-mark">*</i>
            </template>
            <template slot="append">
              <i class="el-icon-arrow-right"></i>
            </template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item prop="city" style="margin-bottom:0.1rem;border:none">
        <el-input v-model="addressForm.city" :placeholder="$t('address.city')" clearable>
          <template slot="prepend">
            <i class="required-mark">*</i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="province">
        <el-input v-model="addressForm.province" :placeholder="$t('address.provice')" clearable>
          <template slot="prepend">
            <i class="required-mark">*</i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="zipCode" style="margin-bottom:0.1rem;border:none">
        <el-input v-model="addressForm.zipCode" :placeholder="$t('address.zipCode')" clearable>
          <template slot="prepend">
            <i class="required-mark">*</i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="vat" style="margin-bottom:0.1rem;border:none">
        <el-input v-model="addressForm.vat" :placeholder="$t('address.vat')" clearable>
          <template slot="prepend">
            <i class="required-mark"> </i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="ioss" style="border:none">
        <el-input v-model="addressForm.ioss" placeholder="ioss" clearable>
          <template slot="prepend">
            <i class="required-mark"> </i>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="height:1.5rem"></div>
    <Footer>
      <el-button type="primary" style="width:100%;height:0.96rem" :loading="loading" @click="editAddress">Submit</el-button>
    </Footer>
  </div>
</template>

<script>
import Footer from '@/components/mobile/Footer'
import API from '@/api'
import Picker from '@/components/mobile/Picker'
import areanolist from '@/config/areanolist.js'
import { telephoneNumber, isValidPostalCode } from '@/util/validate'
let checktelephoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}
export default {
  components: {
    Footer,
    'm-picker': Picker
  },
  data() {
    return {
      addressForm: {
        areaCode: '+1'
      },
      loading: false,
      visible: false,
      countryvisible: false,
      areanolist: [],
      name_en: '',
      rules: {
        fullName: [{ required: true, message: this.$t('common.inputContent'), trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please enter no more than 100 characters' }],
        phoneNumber: [{ required: true, message: this.$t('common.inputContent'), trigger: 'blur' }, { validator: checktelephoneNumber, trigger: 'blur' }, { max: 20, message: 'Please enter no more than 20 characters' }],
        streetAddressLine1: [{ required: true, message: this.$t('common.inputContent'), trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please enter no more than 100 characters' }],
        streetAddressLine2: [{ max: 100, trigger: 'blur', message: 'Please enter no more than 100 characters' }],
        city: [{ required: true, message: this.$t('common.inputContent'), trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please enter no more than 100 characters' }],
        province: [{ required: true, message: this.$t('common.inputContent'), trigger: 'blur' }, { max: 100, trigger: 'change', message: 'Please enter no more than 100 characters' }],
        vatCode: [{ max: 20, message: 'Please enter no more than 20 characters', trigger: 'blur' }],
        vaiosstCode: [{ max: 20, message: 'Please enter no more than 20 characters', trigger: 'blur' }],
        countryCode: [{ required: true, message: this.$t('common.selectContent') }],
        zipCode: [{ required: true, message: this.$t('common.inputContent'), trigger: 'blur' }, { max: 20, message: 'Please enter no more than 20 characters' }, { validator: this.checkisValidPostalCode, trigger: 'blur' }]
      },
      addressData: []
    }
  },
  created() {
    this.areanolist = areanolist
    this.getAddressInfo()
    if (this.$route.query.address) {
      this.addressForm = JSON.parse(this.$route.query.address)
    }
  },
  methods: {
    getCountryName(countryCode) {
      let data = [...this.addressData]
      let arr = data.filter(item => item.code === countryCode)
      if (arr.length > 0) { return arr[0].name_en }
    },
    getAddressInfo() {
      API.getAddressInfo({ dictTypeCode: 'data:address' }).then(res => {
        let data = JSON.parse(res.data)
        this.addressData = data.map(item => { return item.childrens }).flat(2)
        this.name_en = this.getCountryName(this.addressForm.countryCode)
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    confirm(value, row) {
      this.name_en = row.name_en
    },
    checkisValidPostalCode(rules, value, callback) {
      if (isValidPostalCode(value, this.addressForm.countryCode)) {
        callback()
      } else {
        callback(new Error('Please enter your valid zipcode'))
      }
    },
    editAddress() {
      this.addressForm.userId = this.$store.state.common.userId
      this.$refs.addressForm.validate(valid => {
        if (!valid) return
        if (!this.addressForm.areaCode) { return this.$message.error(this.$t('promptText.msg22')) }
        if (!this.addressForm.id) { this.addressForm.id = null }
        this.loading = true
        API.editAddress(this.addressForm).then(res => {
          this.dialogVisible = false
          this.$message.success(this.$t('promptText.msg23'))
          this.$emit('submitForm')
          this.loading = false
          this.$router.push('/personal-center/address-manage')
        }).catch(result => {
          this.$message.error(result.message)
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.back-bar {
  padding-left: 0.2rem;
  width: 100%;
  position: fixed;
  background: #fff;
  top: 0.85rem;
  height: 0.66rem;
  line-height: 0.66rem;
  font-size: 0.32rem;
  color: #7b7b7b;
  z-index: 100;
}
/deep/.el-form-item {
  width: 100%;
  height: 1.2rem;
  background: #fff;
  padding: 0.18rem 0;
  margin-bottom: 0;
  border-bottom: 0.5px solid #cdd4dd;
}
/deep/.el-input__inner {
  border: none;
  padding-left: 0.1rem;
  font-size: 0.32rem;
  height: 0.6rem;
  border-radius: 0;
}
/deep/.el-form-item__content {
  position: relative;
  height: 0.6rem;
  width: 100%;
}
/deep/.el-form-item__error {
  background: #fff;
  width: 100%;
  padding-left: 0.4rem;
}
/deep/.el-input-group__prepend {
  width: 0.32rem;
  background: #fff;
  border: none;
  padding: 0;
  padding: 0 0 0 0.2rem;
  height: 0.6rem;
}
/deep/.el-input-group__append {
  width: 0.32rem;
  background: #fff;
  border: none;
  padding: 0;
  padding-right: 0.2rem;
  font-size: 0.36rem;
  font-weight: 600;
  height: 0.6rem;
  color: #000;
}
.required-mark {
  display: inline-block;
  padding-top: 0.1rem;
  color: #ab1e1a;
  font-size: 0.32rem;
}
/deep/.el-input.el-input--suffix > .el-input__inner,
.el-input > .el-input__inner {
  border-radius: 0;
}
</style>
